import React from 'react';
import { motion } from 'framer-motion';
import logo from '../Assets/Images/rklogo.png';
import { useSelector } from 'react-redux';
import googlePlay from '../Assets/Images/googleplay.png';
import appStore from '../Assets/Images/appStore1.png';
import { useHistory } from 'react-router-dom';

const Footer = () => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const accountType = useSelector((state) => state.auth.accountType);
    const history = useHistory();

    return (
        <motion.div className="w-full  relative">
            {/* <motion.div className="w-full h-9 bg-[#0550B5] text-white font-bold cursor-pointer flex flex-row justify-center items-center">
                Back to Top
            </motion.div> */}
            <motion.div className="w-full bg-[#002557] py-2 px-2">
                <motion.div className="grid bg-white  sm:gap-10 md:gap-0 px-2 py-2 grid-cols-1 sm:grid-cols-1 md:grid-cols-3 xl:grid-cols-3 lg:grid-cols-3">
                    <motion.div className="sm:w-full md:w-auto" onClick={() => history.push('/')}>
                        <img src={logo} alt="logo" />
                    </motion.div>
                    {/* <motion.div className="flex flex-col">
                        <motion.div className="text-[#002557] uppercase font-bold">
                            About us
                        </motion.div>
                        <motion.div className="text-[#002557] text-sm cursor-pointer" onClick={() => history.push('/contactUs')}>
                            Contact us
                        </motion.div>
                    </motion.div> */}
                    <motion.div className="flex flex-col">
                        <motion.div className="text-[#002557] uppercase font-bold">
                            Links
                        </motion.div>
                        <motion.div
                            className="text-[#002557] text-sm cursor-pointer"
                            onClick={() => history.push('/')}
                        >
                            Home
                        </motion.div>
                        <motion.div
                            className="text-[#002557] text-sm cursor-pointer"
                            onClick={() => history.push('/orders')}
                        >
                            Orders
                        </motion.div>
                        <motion.div
                            className="text-[#002557] text-sm cursor-pointer"
                            onClick={() => history.push('/account')}
                        >
                            Profile
                        </motion.div>
                        {isLoggedIn ? (
                            accountType === 'seller' && (
                                <motion.div className="text-[#002557] text-sm cursor-pointer">
                                    Your store
                                </motion.div>
                            )
                        ) : (
                            <motion.div className="text-[#002557] text-sm cursor-pointer">
                                Became a seller
                            </motion.div>
                        )}
                    </motion.div>
                    {/* <motion.div className="flex flex-col md:justify-center md:items-center">
                        <img src={googlePlay} height={200} width={200} alt="playStore" />
                        <img src={appStore} height={200} width={200} alt="appStore" />
                    </motion.div> */}
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default Footer;
